






import { defineComponent } from '@vue/composition-api'
import BaseButton from './BaseButton.vue';

export default defineComponent({
    components: {
        BaseButton
    },
    inheritAttrs: false
}); 

